import { useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';

import { useFetchLeaCoreQuery } from 'generated/graphql';

export const LeaWrapper: React.FC = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const leaId = useMemo(() => searchParams.get('id'), [searchParams]);

  useEffect(() => {
    if (!leaId) {
      navigate('/lea/new');
    }
  }, [leaId, navigate]);

  const { error } = useFetchLeaCoreQuery({
    fetchPolicy: 'network-only',
    variables: { id: leaId ?? '' },
    skip: !leaId,
  });

  useEffect(() => {
    if (error) {
      navigate('..');
    }
  }, [error, navigate]);

  return <Outlet />;
};

LeaWrapper.displayName = 'LeaWrapper';
